<template v-once>
  <div class="list">
        <div class="columns is-centered" v-if="posts && posts.length" key="list">
          <article class="card column is-half" v-for="(post, key) of posts" v-bind:key="key">
            <div class="card-content">
              <h3 class="title is-4">{{post.subj}}</h3>
              <div class="date"><span>{{post.name}}</span> {{post.date | moment}}</div>
              <div class="thumb clip"><figure><img :src="['/bbs/img/' + post.icon + '.gif']" alt="" v-if="post.icon"></figure></div>
              <div class="comment" v-html="post.comment"></div>
            </div>
            <!-- loop start -->
            <ul class="res" v-for="(resa, key2) of post.res" v-bind:key="key2">
              <li class="box">
                <div class="res-comment" v-html="resa.comment"></div>
                <div class="media">
                  <figure class="media-left">
                    <img v-if="resa.name == 'mamoshi'" :src="['/bbs/img/thumb/master.gif']" alt="">
                    <img v-else :src="['/bbs/img/thumb/'+resa.icon+'.gif']" alt="">
                  </figure>
                  <div class="media-content">{{resa.name}}</div>
                </div>
              </li>
            </ul>
            <!-- loop end -->
          </article>
        </div>
        <div v-else-if="errors && errors.length">{{ errors[0].message }}</div>
    
    <ul class="columns is-centered pagenav">
      <li v-if="backlink" class="column is-half"><router-link :to="'/page/'+backlink" class="button">top</router-link></li>
      <li v-else class="column is-half"><router-link to="/" class="button">top</router-link></li>
    </ul>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :canCancel="true"></b-loading>
  </div>
</template>

<script>
export default {
  name: 'thread',
  props: [ 'url', 'cate' ],
  data () {
    return {
      // url: 'http://192.168.0.16:8882/',
      // url: this.url2,
      isLoading: false,
      isFullPage: false,
      posts: [],
      media: [],
      errors: [],
      backlink: ''
    }
  },
  // beforeRouteEnter (route, redirect, next) {
  //   this.setData(route.params.page)
  //   next()
  // },
  // title() {
  //   return this.subj
  // },
  methods: {
    setData (page) {
      this.backlink = page
    },
    test_axios: function () {
      this.openLoading()
      let num = (this.cate) ? 'categories=' + this.cate : ''
      this.$http.get('/bbs/api/api.php?mode=res&no=' + this.$route.params.num, {
        responseType: 'json',
        onDownloadProgress: function (progressEvent) {
          // transfer-encoding:chunked not set total size
          // console.log('aaa', progressEvent, progressEvent.loaded, progressEvent.total)
        }
      })
      .then(function (res) {
        this.isLoading = false
        this.posts = res.data
        document.title = this.posts[0].subj + ' -- Zion Board | IRiE PICT'
      }.bind(this))
      .catch(function (err) {
        this.isLoading = false
        console.log(err.message)
        this.errors.push(err)
      }.bind(this))
    },
    openLoading() {
      const vm = this
      vm.isLoading = true
      // setTimeout(() => {
      //     vm.isLoading = false
      // }, 10 * 1000)
    }
  },
  created () {
    this.backlink = this.$route.params.page
    this.test_axios()
  },
  mounted: function () {
    // this.test_axios()
  }
}
</script>

<style lang="scss" scoped>
figure{
  img{
    filter: saturate(25%) brightness(1.05);
  }
}
.thumb{
  overflow: hidden;
  height: 248px;
  position: absolute;
  top: 0;
  left: 0;
}
.title,.date,.comment{
  padding-left: 130px;
}
.title.is-4{
  margin-bottom: 0.5rem;
}
.date{
  margin-bottom: 1rem;
  span{
    font-weight: bold;
    &::after{
      content: '|';
      font-weight: normal;
      padding: 0 10px;
    }
  }
}
.res{
  position: relative;
  z-index: 1;
  margin: 10px;
  &:not(:last-child){
    margin-bottom: 1rem;
  }
  .box{
    box-shadow: none;
    background: #fbfbfb;
  }
  figure{
    img{
      transform: translateY(0);
    }
    
  }
  .media{
    align-items: center;
    .media-left{
      box-shadow: 0 0 2px rgba(0,0,0,0.3);
    }
  }
}
.res-comment{
  margin-bottom: 1rem;
}
figure{
  // overflow: hidden;
  // border-radius: 50%;
  img{
    filter: saturate(25%) brightness(1.05);
    transform: translateY(-10px);
  }
}
ul.columns{
  margin-top: 2rem;
}
.card{
  overflow: hidden;
}
.pagenav{
  .button{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Thread.vue